import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { formatDate } from 'helpers'

const ExtentedTitle = ({ orderNumber, currentStatusId, orderDate }) => {

    return (
        <Fragment>
            <div className="order__col order__number">
                Nr zamówienia:
                <strong> {orderNumber}</strong>{' '}
            </div>
            <div className="order__col order__status">
                {orderDate && (
                    <span>
                        {{
                            registered: 'Przyjęto',
                            accepted: 'Przyjęto',
                            completed: 'Przyjęto',
                            sent: 'Wysłano',
                            delivered: 'Dostarczono',
                        }[currentStatusId]} <strong>{formatDate(orderDate)}</strong>
                    </span>
                )}
            </div>
        </Fragment>
    );
};

ExtentedTitle.propTypes = {
    orderNumber: PropTypes.string,
    created: PropTypes.string,
};

const OrderHeader = ({ orderNumber, created, title, currentStatusId, orderDate }) => {
    return (
        <div className="order__header">
            {title ? (
                <div className="order__col order__title">{title}</div>
            ) : (
                    <ExtentedTitle orderNumber={orderNumber} created={created} orderDate={orderDate} currentStatusId={currentStatusId} />
                )}
        </div>
    );
};

OrderHeader.propTypes = {
    orderNumber: PropTypes.string,
    created: PropTypes.string,
    title: PropTypes.string,
};

export default OrderHeader;
